import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "earned-card" }
const _hoisted_2 = { class: "earned-card__top" }
const _hoisted_3 = { class: "earned-card__title" }
const _hoisted_4 = { class: "earned-card__money" }
const _hoisted_5 = {
  key: 0,
  class: "earned-card__bottom"
}
const _hoisted_6 = { class: "earned-card__number" }
const _hoisted_7 = { class: "earned-card__payment-system" }

import { computed } from 'vue'

// Store
import { useCommonStore } from '@/store'
import type { CardType } from '@/store/common'

// Components
import Money from '@/components/ui/Money'
import Title from '@/components/ui/Title'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'EarnedCard',
  setup(__props) {

const commonStore = useCommonStore()

// Types
const activeCard = computed<CardType | null>(() => commonStore.user?.cards?.find(item => item.active) ?? null)

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('earned')) + ": ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Title), { theme: "medium" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Money), {
              money: _unref(commonStore).user?.earned
            }, null, 8, ["money"])
          ]),
          _: 1
        })
      ])
    ]),
    (activeCard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, " **** **** **** " + _toDisplayString(activeCard.value.number), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_draw_svg, {
              name: activeCard.value.paymentSystem,
              width: "53",
              height: "53"
            }, null, 8, ["name"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})